import * as React from "react";
import styled from "styled-components";
import "rc-slider/assets/index.css";
import VapeSlider from '../resources/vape_slider.svg';
import Cigarrette from '../resources/cigarrete-2.svg';
import Marijuana from '../resources/marijuana.svg';
import SliderComp from "./SliderComp";

const VapeView = (props) => {

    const [answers, setAnswers] = React.useState([999,999,999])
    const handleAnswerChange = (index, value) => {
        let newAnswers = [...answers];
        newAnswers[index-1] = value;
        setAnswers(newAnswers);
    }

    React.useEffect(() => {
        const unanswered = answers.some(ans => ans === 999);
        
        if (!unanswered) {
            let data = {
                VAP30D: answers[0],
                ANYTOB30D: answers[1],
                MJ30D: answers[2],
            }
            props.setVapeData(data);
            props.setNextButton(true);
            props.onAllAnswered(false);
        } else {
            props.setNextButton(false);
        }
    }, [answers]);
    
    // console.log(answers)

    return(
        <VapeWrap>      
                <h2>Let’s talk about Vaping and Smoking:</h2>
                <h3 style={{marginBottom: '20px'}}>Over the past 30 days, how many days, if any, did you…</h3>
                <QuestionSection>
                    <div style={{marginBottom: '8px'}}>
                    <QuestionNumber>
                        <span>1</span>
                    </QuestionNumber>
                    <h3>Use electronic vapor products?</h3>
                    </div>
                    <p>By electronic vapor products we mean Vapes, vaporizers, vape pens, hookah pens, electronic cigarettes (e-cigarettes or e-cigs), e-pipes, or electronic nicotine delivery systems (ENDS).</p>
                    <SliderComp answer={answers[0]} handleAnswerChange={(value)=>handleAnswerChange(1, value)} icon={VapeSlider} />
                </QuestionSection>
                <QuestionSection>
                    <div style={{marginBottom: '8px'}}>
                    <QuestionNumber>
                        <span>2</span>
                    </QuestionNumber>
                    <h3>Use tobacco?</h3>
                    </div>
                    <p>By tobacco, we mean menthol cigarettes, regular cigarettes, and loose tobacco rolled into cigarettes or cigars, pipe tobacco, snuff, chewing tobacco, dipping tobacco, snus, and others.</p>
                    <SliderComp answer={answers[1]} handleAnswerChange={(value)=>handleAnswerChange(2, value)} icon={Cigarrette} />
                </QuestionSection>
                <QuestionSection>
                    <div style={{marginBottom: '8px'}}>
                    <QuestionNumber>
                        <span>3</span>
                    </QuestionNumber>
                    <h3>Use marijuana or hashish?</h3>
                    </div>
                    <p>Marijuana is sometimes called cannabis, weed, blunt, hydro, grass, or pot. Hashish is sometimes called hash or hash oil.</p>
                    <SliderComp answer={answers[2]} handleAnswerChange={(value)=>handleAnswerChange(3, value)} icon={Marijuana} />              
                </QuestionSection>
            {/* </Form> */}
        </VapeWrap>
    );
}

export const VapeWrap = styled.article`
    h2{
        font-size: 22px;
        /* margin: 0; */
    }
    h3{
        font-size: 18px;
        /* margin: 0; */
        font-weight: normal;
    }
    p{
        font-size: 15px;
        margin: 0;
        /* line-height: 25px; */
    }
    @media only screen and (max-width: 768px) {
        h2{
            font-size: 16px ;
        }
        h3{
            font-size: 14px;
            line-height: 17px;
        }
        p{
            font-size: 12px;
            /* line-height: 13px !important; */
        }
        .drinking-gif{
            width: 20%;
        }
        .clock-gif{
            width: 10%;
        }
    }
    @media only screen and (max-width: 576px) {
        .drinking-gif{
            width: 22%;
        }
        .clock-gif{
            width: 13%;
        }
    }
`;

export const QuestionNumber = styled.div`
background-color: #4D71E5;
width: 20px;
height: 20px;
position: absolute;
    left: -40px;
    top: 3px;
border-radius: 50%;
font-size: 13px;
color: white;
display: flex;
justify-content: center;
@media only screen and (max-width: 780px) {
    width: 13px;
    height: 13px;
    font-size: 9px;
    top: 1px;
    left: -22px;
}
span{
    align-self: center;
    margin-bottom: 3px;
}
`;

export const QuestionSection = styled.section`
position: relative;
    margin: 0;
    padding: 0;
    h3{
        line-height: 1.5;
    }
`;

export default VapeView;